import React, { useRef, useState } from 'react';
import { NodeViewWrapper } from '@tiptap/react';

export const FieldComponent = ({ node, getPos, editor }: any) => {
    const attrs = node.attrs;
    const [isDragging, setIsDragging] = useState(false);
    const dragRef = useRef<HTMLSpanElement>(null);

    // Drag and drop handlers
    const handleDragStart = (e: React.DragEvent) => {
        setIsDragging(true);

        // Set transfer data to identify this node during drag operations
        e.dataTransfer.setData('application/tiptap-field-id', attrs.id || '');
        e.dataTransfer.setData('application/tiptap-field-json', JSON.stringify(attrs));
        e.dataTransfer.setData('text/plain', attrs.title);
        e.dataTransfer.effectAllowed = 'move';

        // For visual feedback during drag
        if (e.dataTransfer.setDragImage && dragRef.current) {
            e.dataTransfer.setDragImage(dragRef.current, 0, 0);
        }
    };

    const handleDragEnd = () => {
        setIsDragging(false);
    };

    return (
        <NodeViewWrapper as="span"
            ref={dragRef}
            draggable={true}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            className="field-dynamic-tag"
            onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
                const pos = getPos() + node.nodeSize;
                editor.commands.focus(pos);
            }}
            style={{
                background: '#f23b5d',
                borderRadius: '5px',
                padding: '3px 5px',
                margin: '0 2px',
                fontWeight: '400',
                userSelect: 'none',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                color: '#fff',
                fontSize: '13px',
                opacity: isDragging ? 0.5 : 1,
            }}>
            {attrs.title}
        </NodeViewWrapper>
    );
};
